module.exports = __webpack_public_path__ + "img/中国公安体育协会(前卫体协)@3x.0c0d493c.png";